import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getRoleComparison = async (token, params) => {
  const url = `roles/${params.role_id}/comparisons/${params.comparison_id}`

  const data = await apiGet({ url, token, params })
  return data
}

export function useRoleComparison({ params, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    [`roles/${params.role_id}/comparison/${params.comparison_id}`, params],
    () => getRoleComparison(token, params),
    {
      ...options
    }
  )
}
